import { useCallback, useMemo, useState } from "react";

export function useDisclosure() {
	const [isOpen, setIsOpen] = useState(false);

	const open = useCallback(() => { setIsOpen(true); }, []);
	const close = useCallback(() => { setIsOpen(false); }, []);
	const toggle = useCallback(() => { setIsOpen(prev => !prev); }, []);

	return useMemo(() => ({ isOpen, open, close, toggle }), [isOpen, open, close, toggle]);
}

export function useDisclosureData<T>(initialData: T) {
	const [isOpen, setIsOpen] = useState(false);
	const [data, setData] = useState<T>(initialData);

	const open = useCallback((newData: T) => {
		setIsOpen(true);
		setData(newData);
	}, []);
	const close = useCallback(() => { setIsOpen(false); }, []);

	return useMemo(() => ({ isOpen, open, close, data }), [isOpen, open, close, data]);
}
